const expectedImageHeightWidth = {
  height: 400,
  width: 980,
}
const expectedSubImageHeightWidth = {
  height: 200,
  width: 300
}
/**
 *
 * @param mainFile {File}
 * @return {Promise}
*/
export function validateImageHeightAndWidth(mainFile, isSubImage = false) {
  const img = new Image();
  img.src = window.URL.createObjectURL(mainFile);

  return new Promise((resolve, reject) => {
      let err = null
      img.onload = () => {
          if (!isSubImage && (img.naturalHeight > expectedImageHeightWidth.height ||
              img.naturalWidth > expectedImageHeightWidth.width)) {
              err = "Picture size must be 980px x 400px"
            }

          if (
            isSubImage && (
            img.naturalHeight > expectedSubImageHeightWidth.height ||
            img.naturalWidth > expectedSubImageHeightWidth.width )
            ) {
            err = "Picture size must be 300px x 200px"
          }
          resolve({dataUrl: img.src, err: err})
      }
      img.onerror = reject
    }
  )
}
